import type { NodeDefinition } from "../domain/types/index.js";

function node(id: string, kind: NodeDefinition["kind"], x: number, y: number, next: readonly string[]): NodeDefinition {
  return { id, kind, x, y, next, ...(kind === "case" ? { caseId: id === "boss" ? "graduation-boss" : id } : {}) };
}

// 第18期。採用拡大・標準化・受け入れ支援の3地域。
// レリックは採用量を伸ばす左と、疲労を残しにくい右の局所ルートに置く。
export const MAP_NODES_GRADUATION: Record<string, NodeDefinition> = Object.fromEntries([
  node("start", "start", 3, 0, ["p18-kickoff"]),
  node("p18-kickoff", "case", 3, 1, ["p18-headcount"]),
  node("p18-headcount", "case", 3, 2, ["p18-campus", "p18-placement", "p18-agency"]),

  node("p18-campus", "case", 1, 3, ["p18-offer", "p18-rest-left"]),
  node("p18-offer", "case", 0, 4, ["p18-batch"]),
  node("p18-rest-left", "rest", 2, 4, ["p18-batch"]),
  node("p18-batch", "case", 1, 5, ["p18-relic-hire", "p18-cohort"]),
  node("p18-relic-hire", "relic", 0, 6, ["p18-scaling"]),
  node("p18-cohort", "case", 2, 6, ["p18-scaling"]),
  node("p18-scaling", "case", 1, 7, ["p18-review-left"]),

  node("p18-placement", "case", 3, 3, ["p18-mentor"]),
  node("p18-mentor", "case", 3, 4, ["p18-event-center"]),
  node("p18-event-center", "event", 4, 5, ["p18-onboarding"]),
  node("p18-onboarding", "case", 3, 6, ["p18-standard", "p18-rest-center"]),
  node("p18-standard", "case", 3, 7, ["p18-review-center"]),
  node("p18-rest-center", "rest", 4, 7, ["p18-workflow"]),
  node("p18-workflow", "case", 4, 8, ["p18-review-center"]),

  node("p18-agency", "case", 5, 3, ["p18-interview", "p18-rest-right"]),
  node("p18-interview", "case", 5, 4, ["p18-intake"]),
  node("p18-rest-right", "rest", 6, 4, ["p18-intake"]),
  node("p18-intake", "case", 5, 5, ["p18-relic-support", "p18-deploy"]),
  node("p18-relic-support", "relic", 6, 6, ["p18-support"]),
  node("p18-deploy", "case", 5, 6, ["p18-support"]),
  node("p18-support", "case", 5, 7, ["p18-review-right"]),

  node("p18-review-left", "case", 1, 10, ["p18-integration-left"]),
  node("p18-review-center", "case", 3, 10, ["p18-integration-left", "p18-integration-right"]),
  node("p18-review-right", "case", 5, 10, ["p18-integration-right"]),
  node("p18-integration-left", "case", 2, 12, ["p18-settlement-left"]),
  node("p18-integration-right", "case", 4, 12, ["p18-settlement-right"]),
  node("p18-settlement-left", "case", 2, 13, ["boss"]),
  node("p18-settlement-right", "case", 4, 13, ["boss"]),
  node("boss", "case", 3, 15, []),
].map((item) => [item.id, item]));
